import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Resolve,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ConfigurationService } from './core/services/configuration.service';

@Injectable()
export class AppCompanyResolverGuard implements Resolve<any> {
  constructor(
    private service: ConfigurationService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.service.resolveCompany().pipe(
      catchError(() => {
        this.router.navigate(['/error/404']);
        return this.emptyCompany();
      })
    );
  }

  emptyCompany() {
    return of({});
  }
}
